import ReactDOM from "react-dom/client";
import reportWebVitals from "./reportWebVitals";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { Home } from "./Pages/Home/Home";
import { Navbar } from "./Components/Navbar/Navbar";
import "./index.css";
import { ThemeProvider } from "@mui/material";
import { theme } from "./Globals/theme";
import { Footer } from "./Components/Footer/Footer";
import { Info } from "./Pages/Info/Info";
import { Gallery } from "./Pages/Gallery/Gallery";
import { Expos } from "./Pages/Expos/Expos";
import { LoginPage } from "./Pages/Login/Login";
import { AdminPage } from "./Pages/Admin/Admin";
import { ContactPage } from "./Pages/Contact/Contact";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(
  <ThemeProvider theme={theme}>
    <BrowserRouter>
      <Navbar />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/info" element={<Info />} />
        <Route path="/gallery" element={<Gallery />} />
        <Route path="/expos" element={<Expos />} />
        <Route path="/contact" element={<ContactPage />} />
        <Route path="/login" element={<LoginPage />} />
        <Route path="/admin" element={<AdminPage />} />
      </Routes>
      <Footer />
    </BrowserRouter>
  </ThemeProvider>
);
reportWebVitals();
